import React, { useState } from 'react';
import {
  FDBodyText, FDDeleteButton, FDIcon, FDStack, FDTableCell, FDTableRow,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { useIncomeCategoryGroupData } from 'Hooks/useIncomeCategoryGroupData';
import { useSnackbarContext } from 'Context/SnackbarContext';

const IncomeInformationTableBodyRow = ({ income, onEditIncome, onDeleteIncome }) => {
  const [loading, setLoading] = useState(false);

  const { displayErrorMessage } = useSnackbarContext();
  const { getIncomeCategoryGroupIcon } = useIncomeCategoryGroupData();

  const handleClick = income.withRelationship(fr.relationships.editIncome.name,
    (rel) => () => {
      if (onEditIncome) {
        onEditIncome(rel.link('related'));
      }
    },
    () => null);

  const handleDelete = async (e) => {
    e.stopPropagation();
    setLoading(true);
    try {
      await income.delete();
      await onDeleteIncome();
    } catch (err) {
      displayErrorMessage(err, err.errors[0]?.detail || 'Unable to delete. If the issue persists please contact your planner.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <FDTableRow hover={!!onEditIncome} onClick={handleClick}>
      <FDTableCell>
        <FDStack
          direction={'row'}
          spacing={1}
          alignItems={'center'}
        >
          <FDIcon icon={getIncomeCategoryGroupIcon(income.attr('group'))} size={'sm'} />
          <FDBodyText value={income.attr('name')} />
        </FDStack>
      </FDTableCell>
      <FDTableCell align={'right'}>
        <FDStack direction={'row'} justifyContent={'flex-end'} alignItems={'center'} spacing={1}>
          <FDBodyText value={income.attr('amount')} />
          {onDeleteIncome && (
            <FDDeleteButton
              appearance={'secondary'}
              size={'sm'}
              loading={loading}
              onClick={handleDelete}
            />
          )}
        </FDStack>
      </FDTableCell>
    </FDTableRow>
  );
};

IncomeInformationTableBodyRow.defaultProps = {
  onEditIncome: undefined,
  onDeleteIncome: undefined,
};

IncomeInformationTableBodyRow.propTypes = {
  income: PropTypes.instanceOf(fr.Resource).isRequired,
  onEditIncome: PropTypes.func,
  onDeleteIncome: PropTypes.func,
};

export { IncomeInformationTableBodyRow };
